import siteConfig from "../../configuration/siteConfiguration";

const featureTexts = [
    "80% Reusable AI Core for rapid market entry",
    "Patent-Pending AI with predictive dashboards & multi-agent collaboration",
    "LLMs for each vertical",
    "Secure, scalable, enterprise ready deployment",
    "Built-in compliance (HIPAA, DPDP, SOC2, RBI/SEBI)",
    "Real-time Copilots for Contracts, Risk, and Governance"
];

export const competencyPills4LargeScreen = [
    {
        type: 'card',
        text: featureTexts[0],
        style: {
            top: "-35px",
            left: "181px"
        }
    },
    {
        type: 'card',
        text: featureTexts[1],
        style: {
            top: "+105px",
            left: "-40px"
        }
    },
    {
        type: 'card',
        text: featureTexts[2],
        style: {
            top: "125px",
            left: "400px"
        }
    },
    {
        type: 'card',
        text: featureTexts[3],
        style: {
            top: "335px",
            left: "-40px",
            paddingRight: "8px"
        }
    },
    {
        type: 'card',
        text: featureTexts[4],
        style: {
            top: "335px",
            left: "400px",
            paddingRight: "8px"
        }
    },
    {
        type: 'card',
        text: featureTexts[5],
        style: {
            top: "458px",
            left: "181px",
            paddingRight: "8px"
        }
    },
    {
        type: 'icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/brain.svg`,
        style: {
            top: "37px",
            left: "406px"
        }
    },
    {
        type: 'icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/legal.svg`,
        style: {
            top: "129px",
            left: "190px"
        }
    },
    {
        type: 'icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/group.svg`,
        style: {
            top: "255px",
            left: "-20px"
        }
    },
    {
        type: 'icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/healthcare.svg`,
        style: {
            top: "265px",
            left: "362px"
        }
    },
    {
        type: 'icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/manufacturing.svg`,
        style: {
            top: "418px",
            left: "149px"
        }
    },
    {
        type: 'icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/shield.svg`,
        style: {
            top: "454px",
            left: "398px"
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-orange-dot.svg`,
        style: {
            top: "37px",
            left: "91px"
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-orange-dot.svg`,
        style: {
            top: "45px",
            left: "237px",
            border: "0px",
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-grey-dot.svg`,
        style: {
            top: "165px",
            left: "342px",
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-orange-dot.svg`,
        style: {
            top: "237px",
            left: "511px",
            border: "0px",
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-orange-dot.svg`,
        style: {
            top: "364px",
            left: "292px",
            border: "0px",
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-orange-dot.svg`,
        style: {
            top: "454px",
            left: "88px",
            border: "0px",
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-grey-dot.svg`,
        style: {
            top: "432px",
            left: "319px",
            border: "0px",
        }
    },

];


export const competencyPills4SmallScreen = [
    {
        type: 'card',
        text: featureTexts[0],
        style: {
            top: "-22px",
            left: "83px"
        }
    },
    {
        type: 'card',
        text: featureTexts[1],
        style: {
            top: "47px",
            left: "-32px"
        }
    },
    {
        type: 'card',
        text: featureTexts[2],
        style: {
            top: "59px",
            left: "196px"
        }
    },
    {
        type: 'card',
        text: featureTexts[3],
        style: {
            top: "169px",
            left: "-35px",
            paddingRight: "8px"
        }
    },
    {
        type: 'card',
        text: featureTexts[4],
        style: {
            top: "168px",
            left: "196px",
            paddingRight: "8px"
        }
    },
    {
        type: 'card',
        text: featureTexts[5],
        style: {
            top: "240px",
            left: "83px",
            paddingRight: "8px"
        }
    },
    {
        type: 'icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/brain.svg`,
        style: {
            top: "24px",
            left: "213px"
        }
    },
    {
        type: 'icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/stack.svg`,
        style: {
            top: "65px",
            left: "103px"
        }
    },
    {
        type: 'icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/group.svg`,
        style: {
            top: "130px",
            left: "-9px"
        }
    },
    {
        type: 'icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/rocket.svg`,
        style: {
            top: "137px",
            left: "187px"
        }
    },
    {
        type: 'icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/refresh.svg`,
        style: {
            top: "213px",
            left: "80px"
        }
    },
    {
        type: 'icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/shield.svg`,
        style: {
            top: "231px",
            left: "209px"
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-orange-dot.svg`,
        style: {
            top: "21px",
            left: "120px"
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-orange-dot.svg`,
        style: {
            top: "45px",
            left: "237px",
            border: "0px",
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-grey-dot.svg`,
        style: {
            top: "76px",
            left: "166px",
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-orange-dot.svg`,
        style: {
            top: "135px",
            left: "256px",
            border: "0px",
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-orange-dot.svg`,
        style: {
            top: "227px",
            left: "40px",
            border: "0px",
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-orange-dot.svg`,
        style: {
            top: "12px",
            left: "40px",
            border: "0px",
        }
    },
    {
        type: 'dot-icon',
        icon: `${siteConfig.assetBaseUrl}/planet-icons/light-grey-dot.svg`,
        style: {
            top: "211px",
            left: "156px",
            border: "0px",
        }
    },

];


export default featureTexts;